import { useLocation, useNavigate, useParams } from '@online-webinar/router';
import { useTranslation } from 'react-i18next';
import { useAuthRedirect } from '../../../hooks/useAuthRedirect';
import { AccountWizardState } from '../../../types';
import { AuthPageTitle } from '../../atoms';
import { AuthPage, AuthPageContent, ForgotPassword, RegisterSideContent } from '../../organism';

export const ForgotPasswordPage = () => {
    const { webinarId } = useParams({ strict: false });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    useAuthRedirect();

    const emailAddress = (location.state?.wizard as AccountWizardState | undefined)?.emailAddress ?? undefined;

    const onBack = () => {
        if (webinarId) {
            navigate({ to: '/$webinarId/login', params: { webinarId }, state: location.state });
        } else {
            navigate({ to: '/login', state: location.state });
        }
    };

    return (
        <AuthPage>
            <AuthPageContent>
                <AuthPageTitle className="mb-8">{t('Pages.ForgotPassword.Header')}</AuthPageTitle>
                <ForgotPassword emailAddress={emailAddress} onBack={onBack} />
            </AuthPageContent>
            <RegisterSideContent />
        </AuthPage>
    );
};
